module.exports = __webpack_public_path__ + "img/shezhi.684bc9fa.png";